import api from 'api'

export const switchCompany = (companyId: number) =>
  api.put<void>(`/admin/company/${companyId}/switch`)
